import { create } from 'zustand';
import EstadoCotizador from '../types/EstadoCotizador';
import Integrante from "../types/Integrante";

const cotizadorStore = create<EstadoCotizador>((set, get) => ({
    pasoActual: 0,
    setPasoActual: (pasoActual: number) => set({ pasoActual }),
    incrementarPaso: () => set((state) => ({ pasoActual: state.pasoActual + 1 })),
    decrementarPaso: () => set((state) => ({ pasoActual: state.pasoActual - 1 })),
    idPlan: -1,
    setIdPlan: (idPlan: number) => set({ idPlan }),
    nombrePlan: '',
    setNombrePlan: (nombrePlan: string) => set({ nombrePlan }),
    descripcionPlan: '',
    setDescripcionPlan: (descripcionPlan: string) => set({ descripcionPlan }),
    cantidadMaximaConyuge: 0,
    setCantidadMaximaConyuge: (cantidadMaximaConyuge: number) => set({ cantidadMaximaConyuge }),
    cantidadMaximaMenores: 0,
    setCantidadMaximaMenores: (cantidadMaximaMenores: number) => set({ cantidadMaximaMenores }),
    cantidadMaximaMayores: 0,
    setCantidadMaximaMayores: (cantidadMaximaMayores: number) => set({ cantidadMaximaMayores }),
    modo: 'mes',
    setModo: (modo: 'mes' | 'año') => set({ modo }),
    formaPago: 'deb/cred',
    setFormaPago: (formaPago: 'efectivo' | 'deb/cred') => set({ formaPago }),
    cantidadIntegrantes: 1,
    setCantidadIntegrantes: (cantidadIntegrantes: number) => set({ cantidadIntegrantes }),
    titular: true,
    setTitular: (titular: boolean) => set({ titular }),
    conyuge: false,
    setConyuge: (conyuge: boolean) => set({ conyuge }),
    hijos: false,
    setHijos: (hijos: boolean) => set({ hijos }),
    cantidadHijos: 0,
    setCantidadHijos: (cantidadHijos: number) => {
        set({ cantidadHijos });
        get().calcularCantidadIntegrantes();
    },
    mayores: false,
    setMayores: (mayores: boolean) => set({ mayores }),
    cantidadMayores: 0,
    setCantidadMayores: (cantidadMayores: number) => {
        set({ cantidadMayores });
        get().calcularCantidadIntegrantes();
    },
    importeTotal: 0,
    setImporteTotal: (importeTotal: number) => set({ importeTotal }),
    reiniciarCotizador: () => {
        set({ pasoActual: 0, idPlan: -1, nombrePlan: '', descripcionPlan: '',
              cantidadMaximaConyuge: 0, cantidadMaximaMenores: 0, cantidadMaximaMayores: 0,
              cantidadIntegrantes: 1, titular: true, conyuge: false, hijos: false, cantidadHijos: 0,
              mayores: false, cantidadMayores: 0, importeTotal: 0, formaPago: 'deb/cred', modo: 'mes',
              importeNormalMenor: 0, importeNormalMayor: 0, importeDebitoMenor: 0, importeDebitoMayor: 0,
              importeAnualMenor: 0, importeAnualMayor: 0, importeNormal: 0, importeDebito: 0, importeAnual: 0, porcentajeDescuento: 0,
              cantidadIntegrantesCargados: 0, titularCargado: false, conyugeCargado: false,
              cantidadHijosCargados: 0, cantidadMayoresCargados: 0, integrantes: [], datosIntegranteOk: false,
              idActual: 0, documentoActual: '', nombresActual: '', apellidoActual: '', tipoActual: '',
              fechaNacimientoActual: '', sexoActual: 'Masc.', emailActual: '', celularActual: '', hayError: false,
              documentoActualError: false, nombresActualError: false, apellidoActualError: false,
              fechaNacimientoActualError: false, emailActualError: false, celularActualError: false, domicilioActual: '', cuilActual: '', domicilioActualError: false, cuilActualError: false,
            });
    },
    importeNormal: 0,
    setImporteNormal: (importeNormal: number) => set({ importeNormal }),
    importeDebito: 0,
    setImporteDebito: (importeDebito: number) => set({ importeDebito }),
    importeAnual: 0,
    setImporteAnual: (importeAnual: number) => set({ importeAnual }),
    importeNormalMenor: 0,
    setImporteNormalMenor: (importeNormalMenor: number) => set({ importeNormalMenor }),
    importeNormalMayor: 0,
    setImporteNormalMayor: (importeNormalMayor: number) => set({ importeNormalMayor }),
    importeDebitoMenor: 0,
    setImporteDebitoMenor: (importeDebitoMenor: number) => set({ importeDebitoMenor }),
    importeDebitoMayor: 0,
    setImporteDebitoMayor: (importeDebitoMayor: number) => set({ importeDebitoMayor }),
    importeAnualMenor: 0,
    setImporteAnualMenor: (importeAnualMenor: number) => set({ importeAnualMenor }),
    importeAnualMayor: 0,
    setImporteAnualMayor: (importeAnualMayor: number) => set({ importeAnualMayor }),
    porcentajeDescuento: 0,
    setPorcentajeDescuento: (porcentajeDescuento: number) => set({ porcentajeDescuento }),
    forzarActualizacion: () => set({}),
    calcularCantidadIntegrantes: () => set ((state) => {
        let cantidad = 0;
        if (state.titular || false) cantidad++;
        if (state.conyuge) cantidad++;
        cantidad += state.hijos ? state.cantidadHijos : 0;
        cantidad += state.mayores ? state.cantidadMayores : 0;
        return {...state, cantidadIntegrantes: cantidad};
    }),
    hayError: false,
    solicitarEmail: '',
    solicitarCelular: '',
    setSolicitarEmail: (solicitarEmail: string) => set({ solicitarEmail }),
    setSolicitarCelular: (solicitarCelular: string) => set({ solicitarCelular }),
    validarEmail: '',
    validarCelular: '',
    setValidarEmail: (validarEmail: string) => set({ validarEmail }),
    setValidarCelular: (validarCelular: string) => set({ validarCelular }),
    pagoOnline: '',
    setPagoOnline: (pagoOnline: string) => set({ pagoOnline }),
    datosGuardados: '',
    setDatosGuardados: (datosGuardados: string) => set({ datosGuardados }),
    setHayError: () => {
        const estadoActual = get();
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

        if (estadoActual.documentoActual.trim().length < 5) {
            set ({ documentoActualError: true });
        }
        if (estadoActual.nombresActual.trim().length < 3) {
            set({ nombresActualError: true });
        }
        if (estadoActual.apellidoActual.trim().length < 3) {
            set({ apellidoActualError: true });
        }
        if (estadoActual.fechaNacimientoActual.trim().length < 10) {
            set({ fechaNacimientoActualError: true });
        }
        if (estadoActual.tipoActual === 'Titular') {
            
            if (estadoActual.solicitarEmail === 'S') {
                if (!emailPattern.test(estadoActual.emailActual)) {
                    set({ emailActualError: true });
                }
            } else {
                set({ emailActualError: false });
            }

            if (estadoActual.solicitarCelular === 'S') {
                if (estadoActual.celularActual.trim().length !== 10) {
                    set({ celularActualError: true });
                }
            } else {
                set({ celularActualError: false });
            }

            if (estadoActual.domicilioActual.trim().length < 5) {
                set({ domicilioActualError: true });
            }
            if (estadoActual.cuilActual.trim().length !== 11) {
                set({ cuilActualError: true });
            }
        } else {
            set({ emailActualError: false });
            set({ celularActualError: false });
            set({ domicilioActualError: false });
        }
        if (estadoActual.documentoActualError || estadoActual.nombresActualError || estadoActual.apellidoActualError || estadoActual.fechaNacimientoActualError || estadoActual.emailActualError || estadoActual.celularActualError || estadoActual.domicilioActualError || estadoActual.paisActual === 0 || estadoActual.provinciaActual === 0 || estadoActual.localidadActual === 0 || estadoActual.cuilActualError) {
            set({ hayError: true });
        } else {
            set({ hayError: false });
        }
    },
    idActual: 0,
    setIdActual: (idActual: number) => set({ idActual }),
    incrementarIdActual: () => set((state) => ({ idActual: state.idActual + 1 })),
    decrementarIdActual: () => set((state) => ({ idActual: state.idActual - 1 })),
    documentoActual: '',
    setDocumentoActual: (documentoActual: string) => {
        const pattern = /^\d{0,8}$/;
        if (pattern.test(documentoActual)) {
            if (documentoActual.trim().length <= 8) {
                set({ documentoActual });
                if (documentoActual.trim().length >= 5 && documentoActual.trim().length <= 8) {
                    set({ documentoActualError: false });
                } else {
                    set({ documentoActualError: true });
                }
            } else {
                set({ documentoActualError: true })
            } 
        }
        get().setHayError();
    },
    documentoActualError: false,   
    setDocumentoActualError: (documentoActualError: boolean) => {
        set({ documentoActualError })
        get().setHayError();
    },
    nombresActual: '',
    setNombresActual: (nombresActual: string) => {
        if (nombresActual.trim().length < 3) {
            set({ nombresActualError: true });
        } else {
            set({ nombresActualError: false });
        }
        set({ nombresActual: nombresActual.toUpperCase()})
        get().setHayError();
    },
    nombresActualError: false,
    setNombresActualError: (nombresActualError: boolean) => set({ nombresActualError }),
    apellidoActual: '',
    setApellidoActual: (apellidoActual: string) => {
        if (apellidoActual.trim().length < 3) {
            set({ apellidoActualError: true });
        } else {
            set({ apellidoActualError: false });
        }
        set({ apellidoActual: apellidoActual.toUpperCase() })
        get().setHayError();
    },
    apellidoActualError: false,
    fechaNacimientoActual: '',
    setFechaNacimientoActual: (fechaNacimientoActual: string, edadMaxima: number) => {
        const estadoActual = get();
        const fechaNacimiento = new Date(fechaNacimientoActual);
        const hoy = new Date();
        const edad = Math.floor((hoy.getTime() - fechaNacimiento.getTime()) / (1000 * 3600 * 24 * 365.25));

        if (estadoActual.tipoActual === 'Titular' || estadoActual.tipoActual === 'Conyuge' || estadoActual.tipoActual === 'Mayor') {
            if (edad < 18 || edad > edadMaxima) {
                set({ fechaNacimientoActualError: true });
            } else {
                set({ fechaNacimientoActualError: false });
                set({ fechaNacimientoActual });
            }
        } else {
            if (estadoActual.tipoActual === 'Menor') {
                if (edad < 0 || edad > edadMaxima) {
                    set({ fechaNacimientoActualError: true });
                } else {
                    set({ fechaNacimientoActualError: false });
                    set({ fechaNacimientoActual });
                }
            } else {
                set({ fechaNacimientoActualError: true });
                set({ fechaNacimientoActual });
            }
        }
        get().setHayError();
    },
    setApellidoActualError: (apellidoActualError: boolean) => set({ apellidoActualError }),
    fechaNacimientoActualError: false,
    setFechaNacimientoActualError: (error: boolean) => {
        set({ fechaNacimientoActualError: error });
        get().setHayError();
    },
    sexoActual: 'Masc.',
    setSexoActual: (sexoActual: 'Masc.' | 'Fem.') => set({ sexoActual }),
    emailActual: '',
    setEmailActual: (emailActual: string) => {
        set({ emailActual });
        const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        if (pattern.test(emailActual)) {
            set({ emailActualError: false });
        } else {
            set({ emailActualError: true });
        }
        get().setHayError();
    },
    emailActualError: false,
    setEmailActualError: (emailActualError: boolean) => {
        set({ emailActualError });
        get().setHayError();
    },
    celularActual: '',
    setCelularActual: (celularActual: string) => {
        const pattern = /^\d{0,10}$/;
        if (pattern.test(celularActual)) {
            set({ celularActual });
            if (celularActual.length === 10) {
                set({ celularActualError: false });
            } else {
                set({ celularActualError: true });
            }
        } else {
            set({ celularActualError: true })
        }
        get().setHayError();
    },
    celularActualError: false,
    setCelularActualError: (celularActualError: boolean) => set({ celularActualError }),
    tipoActual: '',
    setTipoActual: (tipoActual: '' | 'Titular' | 'Conyuge' | 'Menor' | 'Mayor') => {
        set({ tipoActual });
        set({ fechaNacimientoActual: '' });
    },
    paisActual: 1,
    setPaisActual: (paisActual: number) => set({ paisActual }),
    provinciaActual: 1,
    setProvinciaActual: (provinciaActual: number) => set({ provinciaActual }),
    localidadActual: 0,
    setLocalidadActual: (localidadActual: number) => set({ localidadActual }),
    domicilioActual: '',
    setDomicilioActual: (domicilioActual: string) => {
        set({ domicilioActual });
        if (domicilioActual.trim().length < 5) {
            set({ domicilioActualError: true });
        } else {
            set({ domicilioActualError: false });
        }
        get().setHayError();
    },
    domicilioActualError: false,
    setDomicilioActualError: (domicilioActualError: boolean) => set({ domicilioActualError }),
    cuilActual: '',
    setCuilActual: (cuilActual: string) => {
        const pattern = /^\d{0,11}$/;
        if (pattern.test(cuilActual)) {
            set({ cuilActual });
            if (cuilActual.trim().length === 11) {
                set({ cuilActualError: false });
            } else {
                set({ cuilActualError: true });
            }
        } else {
            set({ cuilActualError: true })
        }
        get().setHayError();
    },
    cuilActualError: false,
    setCuilActualError: (cuilActualError: boolean) => set({ cuilActualError }),
    integranteActual: { id: 0, documento: '', apellido: '', nombres: '', fechaNacimiento: '', sexo: 'Masc.', email: '', celular: '', tipo: '', pais: 1, provincia: 1, localidad: 1, domicilio: '', cuil: '', pago_pendiente: '', referencia: '' },
    setIntegranteActual: (integranteActual: Integrante) => set({ integranteActual }),
    cantidadIntegrantesCargados: 0,
    titularCargado: false,
    setTitularCargado: (titularCargado: boolean) => set({ titularCargado }),
    conyugeCargado: false,
    setConyugeCargado: (conyugeCargado: boolean) => set({ conyugeCargado }),
    cantidadHijosCargados: 0,
    setCantidadHijosCargados: (cantidadHijosCargados: number) => set({ cantidadHijosCargados }),
    cantidadMayoresCargados: 0,
    setCantidadMayoresCargados: (cantidadMayoresCargados: number) => set({ cantidadMayoresCargados }),
    setCantidadIntegrantesCargados: (cantidadIntegrantesCargados: number) => set({ cantidadIntegrantesCargados }),
    integrantes: [] as Integrante[],
    agregarIntegrante: (integrante: Integrante) => {
        set((state): EstadoCotizador => {
            const integrantes = state.integrantes;
            integrantes.push(integrante);
            return { 
                ...state,
                integrantes 
            };
        });
    },
    eliminarIntegrante: (id: number) => {
        set((state): EstadoCotizador => {
            const integrantes = state.integrantes.filter(i => i.id !== id);
            return { 
                ...state,
                integrantes 
            };
        });
    },
    actualizarReferenciaIntegrantes: (referencia: string) => {
        const estadoActual = get();
        const integrantesActualizados = estadoActual.integrantes.map(integrante => ({
            ...integrante,
            referencia
        }));
        set({ integrantes: integrantesActualizados });
        return integrantesActualizados;
    },
    datosIntegranteOk: false,
    setDatosIntegranteOk: (datosIntegranteOk: boolean) => set({ datosIntegranteOk }),
    reiniciarCamposActual: () => {
        set({ documentoActual: '', nombresActual: '', apellidoActual: '', tipoActual: '', fechaNacimientoActual: '', sexoActual: 'Masc.', emailActual: '', celularActual: '', domicilioActual: '', cuilActual: '', paisActual: 1, provinciaActual: 1, localidadActual: 1, hayError: true });
    },
    recorrerIntegrantes: () => {
        const estadoActual = get();
        let titularCargadoLocal = false;
        let conyugeCargadoLocal = false;
        let cantidadHijos = 0;
        let cantidadMayores = 0;
        estadoActual.integrantes.forEach((integrante) => {
            if (integrante.tipo === 'Titular') {
                titularCargadoLocal = true;
            }
            if (integrante.tipo === 'Conyuge') {
                conyugeCargadoLocal = true;
            }
            if (integrante.tipo === 'Menor') {
                cantidadHijos++;
            }
            if (integrante.tipo === 'Mayor') {
                cantidadMayores++;
            }
        });
        set({ cantidadIntegrantesCargados: estadoActual.integrantes.length, titularCargado: titularCargadoLocal, conyugeCargado: conyugeCargadoLocal, cantidadHijosCargados: cantidadHijos, cantidadMayoresCargados: cantidadMayores });
    },
    getTitular: (): Integrante => {
        const estadoActual = get();
        const titular = estadoActual.integrantes.find((integrante) => integrante.tipo === 'Titular');
        return titular || { id: -1, documento: '', apellido: '', nombres: '', fechaNacimiento: '', sexo: 'Masc.', email: '', celular: '', tipo: '', pais: 1, provincia: 1, localidad: 1, domicilio: '', cuil: '', pago_pendiente: '', referencia: ''};
    },
    getEmail: () => {
        const estadoActual = get();
        const elTitular = estadoActual.integrantes.find((integrante) => integrante.tipo === 'Titular');
        return elTitular ? elTitular.email : '';
    },
    getCelular: () => {
        const estadoActual = get();
        const elTitular = estadoActual.integrantes.find((integrante) => integrante.tipo === 'Titular');
        return elTitular ? elTitular.celular : '';
    },
    obtenerIntegrantesOrdenados: () => {
        const tiposOrdenados: { [key: string]: number } = {
            'Titular': 1,
            'Conyuge': 2,
            'Menor': 3,
            'Mayor': 4,
        };
    
        const { integrantes } = get();
    
        return integrantes.slice().sort((a, b) => {
            
            const ordenA = tiposOrdenados[a.tipo];
            const ordenB = tiposOrdenados[b.tipo];
    
            if (ordenA < ordenB) return -1;
            if (ordenA > ordenB) return 1;
    
            if (a.tipo === 'Menor') {
                const apellidosComparados = a.apellido.localeCompare(b.apellido);
                if (apellidosComparados !== 0) return apellidosComparados;
                return a.nombres.localeCompare(b.nombres);
            }
    
            if (a.tipo === 'Mayor') {
                const apellidosComparados = a.apellido.localeCompare(b.apellido);
                if (apellidosComparados !== 0) return apellidosComparados;
                return a.nombres.localeCompare(b.nombres);
            }
    
            return 0;
        });
    },
}));

export default cotizadorStore;